<div class="col-lg-12 mb-4 mb-lg-0 p-4 pt-0">
    <h2 class="main-heading text-center">
        Smarter Savings Begin with <br>
        <span class="highlight fw-bold medium">Nishwik’s</span> Smart Vault.
    </h2>
    <p class="col-lg-12 text-center    mt-3 fw-semibold">
        Turn your spare change into smart savings! With Smart Vault, every time you spend, we round
        up your purchase to the nearest rupee and save the difference automatically. It’s effortless,
        automatic,
        and helps you grow your savings with every transaction.<br>
    </p>
    <!-- Custom amount input -->
    <div class="mt-4 text-center" [formGroup]="RoundOffForm" *ngIf="showForm">
        <label for="customAmount" class="form-label form-custom-title  text-center">
            {{!userRoundOffDetails?.isActive ?'Enter Custom Amount': 'Enter Amount'}}
        </label>
        <div class="d-flex justify-content-center">
            <input type="number" formControlName="RoundOffAmount"
                class="form-control w-50 shadow-sm justify-content-between align-items-center " id="customAmount"
                placeholder="E.g., ₹50" (focus)="onInputFocus()" />
        </div>

        <!-- Validation error -->
        <div *ngIf="RoundOffForm.controls.RoundOffAmount.invalid && RoundOffForm.controls.RoundOffAmount.touched"
            class="text-danger small mt-1 text-center">
            Please enter an amount greater than 0.
        </div>
    </div>
    <!-- Popular predefined options -->
    <div *ngIf="!userRoundOffDetails || !userRoundOffDetails.isActive" class="mt-3 text-center">
        <label class="form-label form-custom-title d-block">Or</label>

        <div class="d-flex flex-wrap justify-content-center gap-2">
            <button type="button" class="btn outline-btn rounded-pill px-3 py-1" (click)="selectAmount(25)">₹25</button>
            <button type="button" class="btn outline-btn rounded-pill px-3 py-1" (click)="selectAmount(50)">₹50</button>
            <button type="button" class="btn outline-btn rounded-pill px-3 py-1"
                (click)="selectAmount(100)">₹100</button>
            <button type="button" class="btn outline-btn rounded-pill px-3 py-1"
                (click)="selectAmount(500)">₹500</button>
        </div>

        <div class="d-flex justify-content-center mt-4">
            <a class="btn new-card-btn fw-bold" (click)="SignUpRoundOff()">Start Saving</a>
        </div>
    </div>

    <!-- If already enrolled -->
    <div *ngIf="userRoundOffDetails?.isActive" class="mt-3 text-center">
        <div class="d-flex gap-2 justify-content-center">
            <div class="alert alert-success p-2 fw-semibold text-center w-50">
                🌟 You’re doing great saving! You are already enrolled for Smart Vault with ₹{{
                userRoundOffDetails?.roundOffAmount }} per transaction.
            </div>
        </div>

        <div class="d-flex gap-2 justify-content-center">
            <button class="btn outline-btn" (click)="unenrollRoundOff()"> Unenroll</button>
            <button class="btn outline-btn" *ngIf="showForm" (click)="updateRoundOffAmount()"> Save</button>
            <button class="btn outline-btn " (click)="ShowUpdateForm()" *ngIf="!showForm">Update Amount</button>
        </div>
    </div>
</div>